"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TitleSection = _styledComponents.default.section.withConfig({
  displayName: "TitleSection",
  componentId: "sl01yc-0"
})(["position:relative;background:", ";*{position:relative;}& > *:not(:first-child){margin:", " 0 0;}padding:", " 0;margin-bottom:24px;@media ", "{padding:", " 0;margin-bottom:", ";}&::before{content:'';display:block;position:absolute;background:", ";top:0;bottom:0;z-index:0;width:100vw;left:50%;transform:translateX(-50%);}"], (0, _helpers.color)('neutral-1'), (0, _helpers.getSpacing)('medium'), (0, _helpers.getSpacing)('medium'), (0, _helpers.breakpoint)('maxMobile'), (0, _helpers.getSpacing)('medium'), (0, _helpers.getSpacing)('medium'), (0, _helpers.color)('neutral-1'));

var _default = TitleSection;
exports.default = _default;